<template>
  <main class="products">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">製作事例</h1>
        </div>
				<p  id="DetailHeadUpSp">
当社で製作した製品を紹介します。可能な限りの詳細な情報を記載していますので製作ご依頼の参考にしてください。
				</p>
      </div>

		<div v-show="checkHideContents(FirstLayer)">

				<div class="rowView">
					<sort-panel @parentMethod="updateList" :origin=originList :page-range="50" :page-num=currentPage v-if="setListPanel"></sort-panel>
					<any-list ref="pictureList" @createDetail="createDetail"  @changedDsp="changedDsp" @preparedImage="preparedImage" :display-list="displayList" :any-list="2"></any-list>
				</div>
			</div>
			<router-view v-on:changeDetail="setDetail"></router-view>
		</div>
  </main>
</template>

<script>
import sortPanel from '@/components/SortPanel.vue'
import anyList from '@/components/AnyList.vue'
//const originList = require('@/../public/asset/data/products.json')

export default {
  name: 'products',
  components:{
    sortPanel, 
		anyList,
  },
  data: function () {
    return {
      originList:[],
      displayList:[],
			orderList:[],
			currentPage:1,
      detailIndex:0,
			detailName:'',
			reDisplay:false,
			pageTitle:"製作事例",
			description:"豊嶋精密工業株式会社で製作した製品を紹介します。可能な限りの詳細な情報を記載していますので製作ご依頼の際の参考にしてください。",
			keywords:"製作事例",
			ogType:"product",
			timerID:0,
    }
  },
  computed: {
		setListPanel:function() {
/*直呼び出しの場合、jsonが揃ってから構築しないと、再構築してくれない。
リストなしで構築要求があった場合は、作成しないようにする*/
			return this.originList.length > 0
		},
	},
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
//ページ初期構築時の情報をセットする
    this.setList()
/*パラメータに?list=2の表記があった場合はその対象リストを表示するようにする*/
		if(this.$route.query.list) {
			this.currentPage = Number(this.$route.query.list)
		}
    this.resetList();    
  },
  mounted: function() {this._log("mounted "+this.$options.name)

/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
	
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/products?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}

//		if(this.reDisplay) {
      window.addEventListener('resize', this.mouseUpManage)
//		}
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)

/*ブラウザー戻る進む処理変化の場合は、欠損するデータを補う*/
/*vue-routerで指定するやり方では動かず*/
		if(this.$route.params.anyList == undefined) {
			this.$route.params.anyList = 2 //セットできる プロパティもある状態でセット可能
		}
		if(this.$route.params.detail == undefined) {
			this.detailName = this.$route.params.pageId
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
			this.$route.params.detail  = aImg
		}

		if(this.$route.query.list) {
/*ブラウザーリロード処理変化の場合は、urlに合わせたリスト表示を更新する必要がある*/
			let aPageNumber = Number(this.$route.query.list)
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
			}
		} else {
				this.currentPage = 1
		}
	},
  updated:function() {this._log("updated "+this.$options.name)

		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/products?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
//panel操作の検索/順番変更の対応
// AnyList:imageLoadedで、読み込み終了後correctRow()が呼び出されるため、ここで呼ぶ必要はない
//		this.reDisplay = true
//		this.$refs.pictureList.correctRow()
  },
  methods:{
		startKeyVisualAnime:function() {
//ページ開いた後に実行するアニメーションを記載する 第2階層まで設置必須とする
			this.$refs.pageTitleView.classList.add("rotete2pi")
		},
    createDetail(aImg, index){
this._log("CREATE DETAIL")
      this.detailIndex = index
      this.$router.push({
          name: '製作詳細',
          params: {
              pageId:aImg.title,
							anyList:2,
              detail:aImg,
          },
      })
    },
    setDetail:function(aFor) {
      this.detailIndex += aFor
      if(this.orderList.length <= this.detailIndex) {
        this.detailIndex = 0
      } else if(this.detailIndex < 0 ) {
        this.detailIndex = this.orderList.length-1
      }
      let aImg = this.orderList[this.detailIndex]
      this.$router.push({
          name: '製作詳細',
          params: { 
              pageId:aImg.title,
							anyList:2,
              detail:aImg
          },
      })
    },
    setList() {
			let aList = this.$store.getters.originListProducts.length
			if( aList == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				if(this.detailName != 'products') {
/*詳細ページの場合は一度、リストページに戻す*/
//					this.$router.push({path:"/products"})
					let aFullPath = this.$route.fullPath
					if(this.$route.query.length === 0  ) {
						aFullPath = "/products?List=1"
					}
					this.$router.push({path:aFullPath})
				}else{
/*リストページの場合*/
					this.detailName = ''
				}
				this.$store.watch(
					(state, getters) => getters.originListProducts,
					(newValue, oldValue) => {
						this.originList = this.$store.getters.originListProducts
						this.resetList()
/*詳細ページの場合は以下が必要*/
						if(this.detailName != '') {
							this.rePushDetail()
						}
					}
				)
			} else { //データがある場合
				this.originList = this.$store.getters.originListProducts
				this.resetList()
			}
    },
    resetList() {
      this.displayList = Object.assign([], this.originList)
			this.orderList = Object.assign([], this.originList)
    },
    updateList(aDisplayList, aDisplayListAll, aPageNumber, aPrePageNumber) {
/*子から呼び出す表示更新メソッド*/
      this.displayList = aDisplayList
			this.orderList = aDisplayListAll
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
				this.$router.push({
					name: '製作事例',
					query: { 
							list:aPageNumber,
					}
				})
			}
/*子コンポーネントの更新イベント処理では、不具合（キャッシュイメージ読み込みでloadイベントが発生しない）が出るため、コンポーネントを再構築させる*/
			this.$refs.pictureList.resetComponent()
			if(aPageNumber === aPrePageNumber) {
//前ページと新たなページのが同じ場合、load処理および表示削除処理後のcorrectRowが発動しないため、ここでチェックで発動する
				this.preparedImage()
			}
    },
		changedDsp() {
			this.reDisplay = false
		},
		preparedImage() {
this._log("preparedImage")
//イメージは読み込んだがDOMが生成されないタイミングがある
			this.reDisplay = false
			this.watchCorrectRow()
		},
		mouseUpManage() {
			this.watchCorrectRow()
		},
		watchCorrectRow() {
this._log("watchCorrectRow", this.timerID)
			if(!this.reDisplay) {
//重複してタイマーを起動してしまうのでID管理で一つだけタイマー処理を行う
				if(this.timerID == 0 ) {

//				let aTimeID = setTimeout(()=>{
this._log("ID", this.timerID)
				this.timerID = setTimeout(()=>{
this._log("TIME OUT", this.reDisplay)
					this.reDisplay = true
					this.timerID = 0
this.$refs.pictureList.correctRow()
				}, 1000)

				}
			}
		},

		rePushDetail() {
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
      this.$router.push({
          name: '製作詳細',
          params: { 
              pageId:aImg.title,
              anyList:2,
              detail:aImg
          }
      })
		},
  },
}
</script>


<style>
</style>
